const WORDS = ["Sites profissionais", "Aplicativos", "Sistemas web", "Landing pages", "Lojas virtuais", "Automação", "Plataformas digitais", "Soluções sob medida"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`whitespace-nowrap px-6 font-display text-4xl font-medium tracking-tight sm:px-10 sm:text-6xl lg:text-7xl ${i % 2 ? "text-outline" : "text-ws-text"}`}>
          {w}
        </span>
        <svg width="28" height="28" viewBox="0 0 24 24" className="shrink-0 text-ws-lime" aria-hidden="true">
          <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" fill="currentColor" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee" aria-hidden="true" className="relative overflow-hidden border-y border-white/5 bg-ws-panel py-8 sm:py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ws-panel to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ws-panel to-transparent" />
  </div>
);
